import signature from '@/api/hr/signature'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    return signature.get().then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return signature.store(data)
  },

  update(context, data) {
    return signature.update(data)
  },

  destroy(context, id) {
    return signature.destroy(id)
  }
}
